<template>
    <v-sheet width="360px" class="mx-auto" style="padding: 10px; background: rgb(238,238,238);">
    <div style="display: block;padding-bottom: 130px;">
        
        <div v-if="WearableData == 'unauthorized'">unauthorized to Dataserver</div>
        <div id="loadingSpinner" v-if="isloading == true"><v-progress-circular indeterminate :size="125" :width="11" style="margin-left:120px;margin-top:110px;text-align: center;">loading Smart Wearable</v-progress-circular></div>
        <div id="loadingSpinner" v-if="isloading2 == true"><v-progress-circular indeterminate :size="125" :width="11" style="margin-left:120px;margin-top:110px;text-align: center;">loading Smart Wearable</v-progress-circular></div>
        <div>
            <span>
                <h5 style="text-align: left; padding: 20px 15px;">Aktivität</h5>
                <v-card 
                    style="overflow-y: auto; max-height: 400vh;"
                    rounded="xl"
                    color="#FFFFFF">
                    <div  v-if="hasDataCategoryValues('activity')">
                        <v-table>
                            <!-- Schritte -->
                            <tr class="standardWearableSteps"  v-if='WearableData["Steps"]'>
                                <td class="wearbleNaming">Schritte
                                    <div v-for='entry in WearableData["Steps"]'>
                                        <div class="wearableValueSteps">{{ formatSteps(entry.value) }}</div>
                                        <div class="wearableSourceSteps">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                                <td style="width: 100px;">
                                    <div v-for='entry in WearableData["Steps"]'>
                                    <v-progress-circular :model-value="getStepsPercent(entry.value)" :rotate="360" :size="85" :width="7" color="#ff9933">
                                        <template v-slot:default><table><tr><td style="padding: 0;">{{ getStepsPercent(entry.value) }}</td></tr><tr><td style="padding: 0;font-size: 10px;color: #333333;text-align: center;"><div >10.000</div></td></tr></table></template>
                                    </v-progress-circular>
                                    </div>
                                </td>
                            </tr>
                            <!-- Distanz -->
                            <tr class="standardWearable"  v-if='WearableData["CoveredDistance"]'>
                                <td class="wearbleNaming">Distanz</td>
                                <td>
                                    <div v-for='entry in WearableData["CoveredDistance"]'>
                                        <div class="wearableValue">{{ getKilometer(entry.value) }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Stockwerke -->
                            <tr class="standardWearable" v-if='WearableData["FloorsClimbed"]'>
                                <td class="wearbleNaming">Stockwerke</td>
                                <td>
                                    <div v-for='entry in WearableData["FloorsClimbed"]'>
                                        <div class="wearableValue">{{ entry.value }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Aktive Minuten -->
                            <tr class="standardWearable" v-if='WearableData["ActivityDuration"]'>
                                <td class="wearbleNaming">Aktive Minuten</td>
                                <td>
                                    <div v-for='entry in WearableData["ActivityDuration"]'>
                                        <div class="wearableValue">{{ getHoursToMinutes(entry.value) }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Durchschnittliche Herzfrequenz -->
                            <tr class="standardWearable" v-if='WearableData["HeartRate"]'>
                                <td class="wearbleNaming">Durchschnittliche Herzfrequenz</td>
                                <td>
                                    <div v-for='entry in WearableData["HeartRate"]'>
                                        <div class="wearableValue">{{ entry.value }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Ruhepuls -->
                            <tr class="standardWearable" v-if='WearableData["HeartRateResting"]'>
                                <td class="wearbleNaming">Ruhepuls</td>
                                <td>
                                    <div v-for='entry in WearableData["HeartRateResting"]'>
                                        <div class="wearableValue">{{ entry.value }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Verbrannte Kalorien -->
                            <tr class="standardWearable" v-if='WearableData["ActiveBurnedCalories"]'>
                                <td class="wearbleNaming">Ruhepuls</td>
                                <td>
                                    <div v-for='entry in WearableData["ActiveBurnedCalories"]'>
                                        <div class="wearableValue">{{ entry.value }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                        </v-table>
                    </div>
                    <div class="ma-2" style="padding-left:20px;" v-else>
                        keine Aktivtätsdaten aus Smart Wearables zu diesem Tag
                    </div>
                </v-card>
            </span>

            <span>
                <h5 style="text-align: left; padding: 20px 15px;">Schlaf</h5>
                <v-card 
                    style="overflow-y: auto; max-height: 400vh;"
                    rounded="xl"
                    color="#FFFFFF">
                    <div  v-if="hasDataCategoryValues('sleep')">
                        <v-table>
                            <!-- Schlaf-Effizienz -->
                            <tr class="standardWearableEfficiency" v-if='WearableData["SleepEfficiency"]'>
                                <td class="wearbleNamingSleepEfficiency">Schlaf-Effizienz</td>
                                <td style="width: 110px;">
                                    <div v-for='entry in WearableData["SleepEfficiency"]'>
                                        <v-progress-circular :model-value="entry.value" :rotate="360" :size="80" :width="7" color="#ff9933">
                                        <template v-slot:default>{{ entry.value }}%</template>
                                    </v-progress-circular>
                                    <div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Gesamtschlafzeit -->
                            <tr class="standardWearable" v-if='WearableData["SleepDuration"]'>
                                <td class="wearbleNaming">Gesamtschlafzeit</td>
                                <td>
                                    <div v-for='entry in WearableData["SleepDuration"]'>
                                        <div class="wearableValue">{{ getHoursToMinutes(entry.value) }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Schlafzeit Anfang -->
                            <tr class="standardWearableSleeptimes" v-if='WearableData["SleepStartTime"]'>
                                <td class="wearbleNaming">Schlafzeit Anfang</td>
                                <td>
                                    <div v-for='entry in WearableData["SleepStartTime"]'>
                                        <div class="wearableValue">{{ getHourMin(entry.value) }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Schlafzeit Ende  -->
                            <tr class="standardWearableSleeptimes" v-if='WearableData["SleepEndTime"]'>
                                <td class="wearbleNaming">Schlafzeit Ende</td>
                                <td>
                                    <div v-for='entry in WearableData["SleepEndTime"]'>
                                        <div class="wearableValue">{{ getHourMin(entry.value) }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Zeit im Bett -->
                            <tr class="standardWearable" v-if='WearableData["SleepInBedDuration"]'>
                                <td class="wearbleNaming">Zeit im Bett</td>
                                <td>
                                    <div v-for='entry in WearableData["SleepInBedDuration"]'>
                                        <div class="wearableValue">{{ getHoursToMinutes(entry.value) }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- REM-Schlaf -->
                            <tr class="standardWearable" v-if='WearableData["SleepREMDuration"]'>
                                <td class="wearbleNaming">REM-Schlaf</td>
                                <td>
                                    <div v-for='entry in WearableData["SleepREMDuration"]'>
                                        <div class="wearableValue">{{ getHoursToMinutes(entry.value) }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Tiefschlaf -->
                            <tr class="standardWearable" v-if='WearableData["SleepDeepDuration"]'>
                                <td class="wearbleNaming">Tiefschlaf</td>
                                <td>
                                    <div v-for='entry in WearableData["SleepDeepDuration"]'>
                                        <div class="wearableValue">{{ getHoursToMinutes(entry.value) }}</div><div class="wearableSource">({{ entry.sourcename }})</div>
                                    </div>
                                </td>
                            </tr>
                        </v-table>
                    </div>
                    <div class="ma-2" style="padding-left:20px;" v-else>
                        keine Schlafdaten aus Smart Wearables zu diesem Tag
                    </div>
                    
                </v-card>
            </span>
   <!--          <span v-if="getActivityNameOrFalse(datagroup) != false">
                <u>{{ getActivityNameOrFalse(datagroup) }}</u>
                    <div v-for="(dataentries) in groupeddataentries">
                            <div class="valueRow">
                                <div class="value">{{ dataentries.value }}</div>
                                <div class="valuedevice">{{ dataentries.sourcename }}
                                    <v-tooltip
                                        activator="parent"
                                        location="bottom"
                                    >{{ dataentries.valuedescription  }} &#010; </v-tooltip>
                                </div>
                            </div>
                    </div>
            </span>-->   
        </div>

    </div>
</v-sheet>
</template>

<script>
      import { DataSummaries } from '@/models/DataSummaries'; 
      import { ref, onMounted, onUnmounted, isProxy, toRaw, toRef } from 'vue';
      import { myThryveXMLHTTPRequests } from "@/services/ThryveRequests";
    import { SmartWearableData } from '@/models/SmartWearableData';

    export default {
        name: "WearableData",
        props: {
            ViewDate: Date,
            ViewDateValues: Object
        },
        data (){
            return {
                WearableData:'',
                isloading2:false,
            }
        },
        watch: {
            ViewDate(value, oldValue){
                //console.log(value)
                //console.log(oldValue)
                this.WearableData = this.getThryveData(value);
            }
        },
        methods: {
            async getThryveData(thedate){
                this.isloading2 = true;
                let MySmartWearableData = new SmartWearableData();
                this.WearableData = await MySmartWearableData.getLocalDataToDate(thedate).catch((error) => {
                    //console.log(error)
                    if(error == 'unauthorized'){
                        return 'unauthorized';
                    }
                }).then((res) => {
                    //console.log(res)
                    this.isloading2 = false;
                    return res;
                });
            },
            getKilometer(meter){
                return (Number.parseFloat(meter/1000).toFixed(1))+' km'
            },
            formatSteps(steps){
                steps = Number.parseInt(steps)
                return steps.toLocaleString("de-DE")
            },
            getHoursToMinutes(min){
                let time = min*60;
                let std = Math.floor(time / 3600 );
                let minu = Math.floor( (time % 3600) / 60 )
                let retSTrg = ''
                if(std > 0)retSTrg=retSTrg+std+'h '
                return retSTrg+Math.floor( (time % 3600) / 60 )+'min';
            },
            getHourMin(hourMin){
                return hourMin.substring(11, 16)+' Uhr'
            },
            getStepsPercent(steps){
                return ((steps/10000)*100).toFixed(1)+'%'
            },
            hasDataCategoryValues(catname){
                let countTrues = 0;
                switch(catname){
                    case "activity":
                            if(typeof this.WearableData["Steps"] != 'undefined' )
                                if(this.WearableData["Steps"].length > 0)countTrues++;
                            if(typeof this.WearableData["CoveredDistance"] != 'undefined' )
                                if(this.WearableData["CoveredDistance"].length > 0)countTrues++;
                            if(typeof this.WearableData["FloorsClimbed"] != 'undefined' )
                                if(this.WearableData["FloorsClimbed"].length > 0)countTrues++;
                            if(typeof this.WearableData["ActivityDuration"] != 'undefined' )
                                if(this.WearableData["ActivityDuration"].length > 0)countTrues++;
                            if(typeof this.WearableData["HeartRate"] != 'undefined' )
                                if(this.WearableData["HeartRate"].length > 0)countTrues++;
                            if(typeof this.WearableData["HeartRateResting"] != 'undefined' )
                                if(this.WearableData["HeartRateResting"].length > 0)countTrues++;
                            if(typeof this.WearableData["ActiveBurnedCalories"] != 'undefined' )
                                if(this.WearableData["ActiveBurnedCalories"].length > 0)countTrues++;
                        break;
                    case "sleep":
                            if(typeof this.WearableData["SleepEfficiency"] != 'undefined' )
                                if(this.WearableData["SleepEfficiency"].length > 0)countTrues++;
                            if(typeof this.WearableData["SleepDuration"] != 'undefined' )
                                if(this.WearableData["Steps"].length > 0)countTrues++;
                            if(typeof this.WearableData["SleepStartTime"] != 'undefined' )    
                                if(this.WearableData["SleepStartTime"].length > 0)countTrues++;
                            if(typeof this.WearableData["SleepEndTime"] != 'undefined' )    
                                if(this.WearableData["SleepEndTime"].length > 0)countTrues++;
                            if(typeof this.WearableData["SleepInBedDuration"] != 'undefined' )    
                                if(this.WearableData["SleepInBedDuration"].length > 0)countTrues++;
                            if(typeof this.WearableData["SleepREMDuration"] != 'undefined' )    
                                if(this.WearableData["SleepREMDuration"].length > 0)countTrues++;
                            if(typeof this.WearableData["SleepDeepDuration"] != 'undefined' )    
                                if(this.WearableData["SleepDeepDuration"].length > 0)countTrues++;
                        break;
                }
                
                if(countTrues > 0){
                    return true
                }else{
                    return false
                }
            },
            getActivityNameOrFalse(name){
                let ToShow = { 
                    "Steps":"Schritte",
                    "CoveredDistance":"Distanz",
                    "FloorsClimbed":"Etagen",
                    "BurnedCalories":"Gesamtkalorien",
                    "ActiveBurnedCalories":"Verbrannte Kalorien",
                    "ActivityDuration":"Gesamtdauer der Aktivitäten",
                    "ActiveDuration":"Aktive Minuten",
                    "SleepDuration":"Gesamtschlafzeit",
                    "SleepInBedDuration":"Zeit im Bett",
                    "SleepREMDuration":"REM-Schlaf",
                    "SleepDeepDuration":"Tiefschlaf",
                    "SleepStartTime":"Schlafenszeit Anfang",
                    "SleepEndTime":"Schlafenszeit Ende",
                    "SleepEfficiency":"Schlaf-Effizienz",
                    "HeartRate":"Durchschnittliche Herzfrequenz",
                    "HeartRateResting":"Ruhepuls",
                }

                if(typeof ToShow[name] != 'undefined'){
                    return ToShow[name]
                }else{
                    return false
                }
            }
        },
        setup (props) {
            let isloading = ref(true)
            let ViewDate = toRef(props, 'ViewDate')
            let WearableData = ref({})
            let MySmartWearableData = new SmartWearableData();
            onMounted(
                async () => {
                    WearableData.value = await MySmartWearableData.getLocalDataToDate(ViewDate.value).catch((error) => {
                        console.log(error)
                        if(error == 'unauthorized'){
                            return 'unauthorized';
                        }
                    }).then((SWdata) => {
                        isloading.value = false;
                        WearableData.value = SWdata
                        return SWdata;
                    });
                },
            )
            return {
                WearableData,
                ViewDate,
                isloading
            }
        }
    }
</script>

<style>
    .v-overlay__scrim{
      top: 66px;
      bottom: 60px;
    }
    #dayOverlayDatas .v-overlay__content{
        height: 100%;
    }
    .thryvedata{
        text-align: center;
    }
    .thryvedata u{
        margin-top: 20px;
        display: block;
    }
    .valueRow{
        display:flex;
    }
    .value{
        width: 50%;
        text-align: right;
        margin-right:5px;
    }
    .valuedevice{
        width: 50%;
        text-align: left;
        margin-left:5px;
    }
    .overlaycontent{
        overflow-y: scroll;
    }
    .standardWearable td{
        padding-top: 15px;
        padding-bottom: 15px;
        border-top: 1px solid black;
        font-size: 14px;
        font-weight: bold;
    }
    .standardWearableSleeptimes td{
        font-size: 12px;
        font-weight: normal;
        color: #333333;
        padding-left: 20px;
    }
    .wearbleNaming{
        padding-left: 20px;
        text-align: left;
        vertical-align: top;
        font-weight: bold;
    }
    .wearableValue{
        padding-right: 20px;
        text-align: right;
    }
    .wearableSource{
        padding-right: 20px;
        text-align: right;
        font-size: 12px;
        color: #333333;
        font-weight: normal;
    }
    .wearbleNamingSteps td{
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 14px;
        font-weight: bold;
    }
    .wearableValueSteps{
        font-size: 26px;
        font-weight: bold;
    }
    .wearableSourceSteps{
        padding-left: 10px;
        text-align: left;
        font-size: 12px;
    }
    .standardWearableEfficiency td{
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 14px;
        font-weight: bold;
    }
    .wearbleNamingSleepEfficiency{
        font-size: 20px !important;
        padding-left: 10px;
    }
    .standardWearableSteps td{
        padding-top: 30px;
        padding-bottom: 30px;
    }
    #loadingSpinner{
        width: 360px;
        height: 300px;
        position: absolute;
        background: rgb(238, 238, 238);
        margin-left: -10px;
        z-index: 2;
    }
</style>
